<template>
  <div class="content">

    <section class="hero is-info is-medium is-bold">
      <div class="hero-body">
        <div class="container">
          <p class="has-text-weight-normal">Session ouverte...</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>
